// noinspection JSIgnoredPromiseFromCall

import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { patchVehicle } from '../../services/VehiclesService';
import { Vehicle, PatchVehicleRequest } from '../../types/Vehicles';

type Result = UseMutationResult<Vehicle, Error, PatchVehicleRequest>;

function usePatchVehicle(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(patchVehicle, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['vehicle'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default usePatchVehicle;
